import { useEffect, useRef, useState } from 'react';

interface LaptopMockupProps {
  videoSrc: string;
  posterSrc?: string;
  alt?: string;
  className?: string;
}

export default function LaptopMockup({ videoSrc, posterSrc, alt = 'Demo video', className = '' }: LaptopMockupProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (isVisible) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isVisible]);

  return (
    <div className={`flex justify-center ${className}`} ref={containerRef}>
      <div className="laptop-mockup">
        {/* Screen */}
        <div className="laptop-screen">
          <video
            ref={videoRef}
            src={videoSrc}
            poster={posterSrc}
            muted
            loop
            playsInline
            aria-label={alt}
            className="laptop-video"
          />
        </div>
        {/* Base / Keyboard */}
        <div className="laptop-base">
          <div className="laptop-notch" />
        </div>
        <div className="laptop-bottom" />
      </div>
    </div>
  );
}
